module.exports = __webpack_public_path__ + "img/ເວບໄຊ-laodl-1400x488.4e894473.jpg";